import { gql } from "@apollo/client";

export const CreateGridView = gql`
    mutation CreateGridView ($input: GridViewCreateAttributesInput!){
        createGridView(input: $input) {
            id
            title
        }
    }
`;
